import React, { Component } from "react";
const roundPlug = <img src="assets/images/featured/macApplePlugify.png" alt="Apple Resseler Plugify" />


class AboutApple extends Component {
    render() {
        let title = 'Compatibilidade ao seu alcance',
            description = 'Integrada com VPN. O iOS, o iPadOS e o macOS já são compatíveis com as redes-padrão IKEv2, Cisco IPsec e L2TP sobre IPsec. e também com VPN Sob Demanda, VPN Sempre Ativa e VPN por App.';

            let title2 = 'Seguro do início ao ﬁm',
            description2 = 'A Plataforma Apple é reconhecida como uma das mais seguras do mercado mundial.';

            let title3 = 'Produtividade em qualquer lugar',
            description3 = 'Seu time merece a experiência integrada dos dispositivos Apple - iPhone, iPad e MacBook.';

        return (
            <React.Fragment>
                <div className="bg-about-plug">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35">
                                <div className="col-lg-12 col-md-12 imgMac">
                                    <div className="thumbnail">
                                        {roundPlug}
                                    </div>
                                </div>
                               
                                <div className="col-lg-4 col-md-12">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="titleProdApple2">{title}</h2>
                                            <span className="descriptionApple3">{description}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-12">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="titleProdApple2a">{title2}</h2>
                                            <span className="descriptionApple3">{description2}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-12">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="titleProdApple2 ">{title3}</h2>
                                            <span className="descriptionApple3">{description3}</span>
                                        </div>
                                    </div>
                                </div>
                              
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default AboutApple;